const SupportedDatasources = [
    {
        'datasource_type': 'bigquery',
        'datasource_type_name': 'Google BigQuery',
    },
    {
        'datasource_type': 'postgres',
        'datasource_type_name': 'PostgreSQL',
    },
    {
        'datasource_type': 'mysql',
        'datasource_type_name': 'MySQL',
    },
    {
        'datasource_type': 'presto',
        'datasource_type_name': 'Presto',
    }
]

export default SupportedDatasources;


// WEBPACK FOOTER //
// ./src/constants/datasources.js